import type { CounterState } from './counter.types';

const PROD_API_URL =
  'https://dxpuw6f7o9.execute-api.eu-central-1.amazonaws.com/dev/';

function getBaseUrl(): string {
  const isDevServer =
    import.meta.env.DEV && window.location.protocol === 'http:';
  if (isDevServer) return '';
  return import.meta.env.VITE_API_URL ?? PROD_API_URL;
}

// Public, unauthenticated read of the live counter state.
export async function getCounterState(): Promise<CounterState> {
  const base = getBaseUrl().replace(/\/$/, '');
  const response = await fetch(`${base}/api/v1/counter`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Counter fetch failed (${response.status})`);
  }

  return (await response.json()) as CounterState;
}
